<div id="leave-dialog-container" #form>
  <header>
    <div class="title">
      {{title}}
    </div>

    <div class="close-icon" (click)="close()">
      <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
    </div>
  </header>

  <section class="body">
    <div class="service-personal-info">
      <div class="col-md-6 text">
        <div class="row displayname">
          <div class="col-md-12">
            <span class="text-label">{{'servicePersonnel.name'| translate}} </span>
          </div>
      </div>
      <div class="row" style="margin-top: 0.2rem">
        <div class="col-md-12">
          <span class="text-content">{{data.employee.firstName}} {{data.employee.lastName}} </span>
        </div>
      </div>
      </div>
      <div class="col-md-3 text">
        <div class="row displayname">

          <div class="col-md-12">
            <span class="text-label">{{'servicePersonnel.dmsId'| translate}} </span>
          </div>
        </div>
        <div class="row" style="margin-top: 0.2rem">

          <div class="col-md-12">
            <span class="text-content">{{data.employee.externalId}}</span>
          </div>

        </div>

      </div>
    </div>
    <div class="calendar-container">
        <div id="asp-leave-calendar">
          <mat-calendar #leavecalendar
          [headerComponent]="customHeader"
          (selectedChange)="dateChange($event,calendar)"
          (monthSelected)="monthChange($event)"
          [minDate]="minDate"
           [dateClass]="dateClass" class="col-md-12">
         </mat-calendar>
        </div>
      <div class="leave-type-container">
        <div  class="leave-type-identifier">
          <div class="square Holiday"></div>
          <span class="leave-name">{{'common.Holiday'| translate}}</span>
        </div>
        <div class="leave-type-identifier" *ngFor="let leave of leaves">
          <div class="square {{leave.name}}"></div>
          <span class="leave-name">{{getTranslation(leave.name)}}</span>
        </div>

      </div>
    </div>
    <div class="leave-type-container">
      <h6 id="title">{{'servicePersonnel.addNewLeave'| translate}}
        <ng-container *ngIf="daysSelected && daysSelected.length>0">
          -
          <ng-container *ngFor="let day of daysSelected;let i = index;let last =last">
            <span *ngIf="i<=1">
              {{day}},
            </span>
            <span *ngIf="i>1 && last">
              ...
            </span>
          </ng-container>
        </ng-container>
      <ng-template #moreoption>
        <span>...</span>
      </ng-template>
      </h6>
      <div class="leave-type-form">
        <div class="col-md-6 leave-input">
          <div class="row"><label>{{'servicePersonnel.selectType'| translate}}</label></div>
          <div class="row">
            <mat-form-field class="mat-input-container anime-element" appearance="outline">
              <mat-select  placeholder="{{'servicePersonnel.selectALeavetype' | translate}}">
                <mat-option *ngFor="let leavetype of (leaves | alphabetize:'name')" [value]="leavetype.name" (click)="setLeaveType(leavetype.name)">
                  {{ getTranslation(leavetype.name)}}
                  <span *ngIf="leavetype.name.includes('ly')"> {{'departmentHolidays.recurrent'| translate}}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6" >
          <div class="row"><label>{{'servicePersonnel.duration'| translate}}</label></div>
          <div class="row Day-Type-radio-group">
          <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="dayType">
            <mat-radio-button value="1" [value]="'FULL'">{{'common.fullDay'| translate}}</mat-radio-button>
            <mat-radio-button value="2" [value]="'HALF'">{{'common.halfDay'| translate}}</mat-radio-button>
          </mat-radio-group>
        </div>
          <div class="col-md-12 row am-pm-button-toggle" *ngIf="dayType === 'HALF'">
            <div class="col-md-8"></div>
            <div class="col-md-4">
              <mat-button-toggle-group  name="fontStyle" aria-label="Font Style" value="AM" [(ngModel)]="dayTime">
                <mat-button-toggle value="AM">
                    <span>{{'common.AM'| translate}}</span>
                </mat-button-toggle>
                <mat-button-toggle value="PM">
                    <span>{{'common.PM'| translate}}</span>
                </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer >
    <div >
      <button class="asp-btn asp-btn-secondary cancel-button" (click)="close()">
        <span>{{'overrideCapacity.cancel'| translate}}</span>
      </button>
    </div>
    <div style="width: 100%;margin-left: 3rem;">
      <button class="asp-btn asp-btn-secondary delete-button" (click)="openConfirmDialog('delete')"
      [ngClass]="(isDeleteButtonEnable)?'btn-disabled-color':''"
      [disabled]="isDeleteButtonEnable">
        <span>{{'servicePersonnel.delete'| translate}}</span>
      </button>
    </div>
    <div class="add-button" style="width: 100%;margin-left: 1rem;">
      <button class="asp-btn asp-btn-primary save-button" (click)="onSave()"
      [ngClass]="(isValidForm())?'btn-disabled-color':''"
      [disabled]="isValidForm()">
        <span>{{'overrideCapacity.save'| translate}}</span>
      </button>
    </div>
  </footer>
</div>
